// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"afbd7a36","232":"b0e18bac","242":"859816c7","337":"b19667b1","476":"e80b2f30","706":"5d993f57","738":"ea764d55","804":"2460780c","847":"e9d86645","882":"6dcfdf5b","939":"dbe2a2f5","965":"fb311c9c","993":"a6ddd97a"}[chunkId] + ".chunk.js";
};